import {
    Box,
    Card,
    CardContent,
    CardMedia,
    Grid,
    Typography,
} from '@material-ui/core';
import CardActionArea from '@material-ui/core/CardActionArea';
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';
import styled from 'styled-components';

export const StyledSection = styled.section`
    display: flex;
    justify-content: center;
    &:nth-child(odd) {
        color: white;
        background: rgb(176, 57, 57);
    }
    &:nth-child(even) {
        color: black;
        background-color: white;
    }
    &:first-child {
        background-image: linear-gradient(
                rgba(120, 20, 20, 0.85),
                rgba(120, 20, 20, 0.85)
            ),
            url('https://sind-storage.ams3.cdn.digitaloceanspaces.com/media/eventimages/236_2.png');
        background-position: center top;
        background-size: cover;
    }
`;

export const StyledSectionBox = styled(Box)`
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    min-width: 0px;
    max-width: 1200px;
    padding: ${({ theme }) => theme.spacing(10, 4)};
    text-align: center;

    & a {
        color: inherit;
        text-decoration: none;

        &:hover {
            text-decoration: underline;
        }
    }
`;

export const StyledLoadingOverlay = styled(Box)<{ $visible: boolean }>`
    position: absolute;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
    visibility: ${({ $visible }) => ($visible ? 'visible' : 'hidden')};
`;

export const StyledStatisticsBox = styled(Box)<{ $visible: boolean }>`
    visibility: ${({ $visible }) => ($visible ? 'visible' : 'hidden')};
`;

export const StyledLogosWrapper = styled(Box)`
    display: flex;
    justify-content: center;
    padding-top: ${({ theme }) => theme.spacing(8)}px;
    padding-bottom: ${({ theme }) => theme.spacing(10)}px;
`;

export const StyledLogosBox = styled(Box)`
    width: 100%;
    max-width: 800px;
    height: 100px;
    margin: 20px auto;

    ${({ theme }) => theme.breakpoints.down('md')} {
        height: auto;
        min-height: 100px;
    }
`;

export const StyledMapWrapper = styled(Box)`
    height: 80vh;
`;

export const StyledSectionTitle = styled(Typography)`
    padding-bottom: 20px;
`;

export const StyledSectionSubtitle = styled(Typography)`
    padding-bottom: 40px;
`;

export const StyledAreasGrid = styled(Grid)`
    display: flex;
    flex-wrap: wrap;
    gap: 80px;
    justify-content: center;
    padding: ${({ theme }) => theme.spacing(2, 4)};
`;

export const StyledAreasCard = styled(Card)`
    width: 280px;
`;

export const StyledAreasCardActionArea = styled(CardActionArea)`
    display: flex;
    align-items: baseline;
    height: 100%;
`;

export const StyledAreasCardContent = styled(CardContent)`
    width: 100%;
    padding: 20px;
`;

export const StyledAreasCardTopGrid = styled(Grid)`
    padding-bottom: 5px;
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
`;

export const StyledAreasCardBottomGrid = styled(Grid)`
    padding-top: 16px;
    color: #777;
`;

export const StyledCountryOutlineIcon = styled.div`
    svg {
        height: 50px;
        margin: 10px 0px;
    }
`;

export const StyledExploreGrid = styled(Grid)`
    justify-content: center;
    padding: 20px;
`;

export const StyledCardGrid = styled(Grid)`
    flex-grow: 1;
`;

export const StyledCard = styled(Card)`
    height: 100%;
`;

export const StyledCardActionArea = styled(CardActionArea)`
    display: flex;
    flex-direction: column;
    height: 100%;
`;

export const StyledCardMedia = styled(CardMedia)`
    width: 100%;
    height: 260px;
`;

export const StyledCardContent = styled(CardContent)`
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    width: 100%;
`;

export const StyledCardHeader = styled(Typography)`
    width: 100%;
    padding-bottom: 10px;
`;

export const StyledExploreCardBox = styled(Box)`
    flex-grow: 1;
    gap: 20px;
`;

export const StyledCardDescription = styled(Typography)`
    flex-shrink: 1;
    align-self: flex-start;
`;

export const StyledExploreCardCta = styled(Typography)`
    flex-grow: 1;
    flex-shrink: 0;
    color: rgb(176, 57, 57);
    font-weight: bold;
    white-space: nowrap;
`;

export const StyledArrowForwardIcon = styled(ArrowForwardIcon)`
    margin-left: 2px;
    vertical-align: middle;
`;

export const StyledResourcesGrid = styled(Grid)`
    padding: 20px;
`;

export const StyledResourcesCardCta = styled(Typography)`
    flex-grow: 1;
    flex-shrink: 0;
    align-content: end;
    color: rgb(176, 57, 57);
    font-weight: bold;
    white-space: nowrap;
`;

export const StyledContentSectionTitle = styled(Typography)`
    padding-bottom: 50px;
`;

export const StyledResourcesContainer = styled(Box)`
    text-align: justify;

    ${({ theme }) => theme.breakpoints.down('xs')} {
        text-align: center;
    }
`;

export const StyledAcknowledgementsTitle = styled(Typography)`
    padding-bottom: 30px;
`;

export const StyledAcknowledgementsTypography = styled(Typography)`
    padding-top: ${({ theme }) => theme.spacing(10)}px;
`;
